import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  protected get apiUrl(): string {
    return `${environment.API_URL}`;
  }

  private baseUrl: string = '';

  public languageSubject$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public isChangeLanguage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private dataShared$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // private dataHeader$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  // private dataFooter$: BehaviorSubject<any> = new BehaviorSubject<any>({
  //   data: null,
  //   dataEnd: null
  // });

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private title: Title, 
    private meta: Meta
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.baseUrl = this.document.location.origin;
      console.log(this.baseUrl)
    }
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  setDataShared(data: any) {
    this.dataShared$.next(data);
  }

  getDataShared() {
    return this.dataShared$.asObservable();
  }

  setLanguage(lang: string) {
    this.languageSubject$.next(lang);
  }

  getChangeLanguage() {
    return this.isChangeLanguage$.asObservable();
  }

  setChangeLanguage() {
    this.isChangeLanguage$.next(true);
  }

  getLanguage() {
    return this.languageSubject$.asObservable();
  }

  getLanguageStr() {
    return this.languageSubject$.getValue();
  }

  getData(path: string) {
    return this.http.get(`api/services/app/Slug/GetBySlug?slug=${path}`)
  }

  getDataNews(body: any) {
    return this.http.post(`api/services/app/Slug/SearchNews`, body)
  }
  
  getDataNewsByEvent(body: any) {
    return this.http.post(`api/services/app/Slug/SearchNewsByEvent`, body)
  }

  getDataBreadcrumb(path: string) {
    return this.http.get(`api/services/app/Slug/GetBreadcumbData?slug=${path}`)
  }
  
  getAnalyticsData() {
    return this.http.get(`api/services/app/Analytic/GetAnalyticsData`)
  }

  submitContact(body: any) {
    return this.http.post(`api/services/app/ContactInfos/RegisterContract`, body)
  }

  async updateMeta(
    name?: string, 
    content?: string, 
    property?: string,
    itemprop?: string
  ) {
    const metaTag: { [key: string]: string } = {};
  
    if (name) {
      metaTag['name'] = name;
    }
    if (property) {
      metaTag['property'] = property;
    }
    if (content) {
      metaTag['content'] = content;
    }
    if (itemprop) {
      metaTag['itemprop'] = itemprop;
    }
  
    // Update meta tag
    this.meta.updateTag(metaTag);
  }
  
}
